// extracted by css-extract-rspack-plugin
export default {"alert-severity-tag":"src-features-Weather-features-WeatherAlerts-features-AlertList-features-AlertCard-AlertCard-module__alert-severity-tag-p8DoAN","alertSeverityTag":"src-features-Weather-features-WeatherAlerts-features-AlertList-features-AlertCard-AlertCard-module__alert-severity-tag-p8DoAN","alert-severity-label":"src-features-Weather-features-WeatherAlerts-features-AlertList-features-AlertCard-AlertCard-module__alert-severity-label-Avxejg","alertSeverityLabel":"src-features-Weather-features-WeatherAlerts-features-AlertList-features-AlertCard-AlertCard-module__alert-severity-label-Avxejg"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"alert-severity-tag\":\"src-features-Weather-features-WeatherAlerts-features-AlertList-features-AlertCard-AlertCard-module__alert-severity-tag-p8DoAN\",\"alertSeverityTag\":\"src-features-Weather-features-WeatherAlerts-features-AlertList-features-AlertCard-AlertCard-module__alert-severity-tag-p8DoAN\",\"alert-severity-label\":\"src-features-Weather-features-WeatherAlerts-features-AlertList-features-AlertCard-AlertCard-module__alert-severity-label-Avxejg\",\"alertSeverityLabel\":\"src-features-Weather-features-WeatherAlerts-features-AlertList-features-AlertCard-AlertCard-module__alert-severity-label-Avxejg\"}";
        // 1790730173173
        var cssReload = require("../../../../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  